/*
  Capa «Campaña»: cuenta regresiva y cambio de estado en vivo.

  El estado inicial ya lo dejó el script inline de snippets/fls-campaign-head
  (clase fls-campaign--pre|on|post en <html>). Este archivo solo:
    - rellena los nodos [data-fls-countdown] (franja superior, cabecera de
      la colección) con lo que falta para el inicio o para el término;
    - vuelve a evaluar el estado cada segundo, al volver a la pestaña y al
      restaurar la página desde el caché del navegador, así la franja se
      apaga sola a la hora exacta sin recargar.

  La cuenta regresiva es aria-hidden: un lector de pantalla no debe oír un
  reloj cada segundo. La fecha de término va como texto fijo al lado.
*/
(function () {
  var c = window.flsCampaign;
  if (!c) return;

  var timer = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function set(node, sel, value) {
    var el = node.querySelector(sel);
    if (el && el.textContent !== value) el.textContent = value;
  }

  function tick() {
    var st = c.apply();
    if (st === 'post') { stop(); return; }
    var left = Math.max(0, (st === 'pre' ? c.start : c.end) - c.now());
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var nodes = document.querySelectorAll('[data-fls-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      // Bajo un día sobran los días: se esconden para que quepa en móvil.
      n.classList.toggle('is-under-day', d === 0);
      set(n, '[data-fls-d]', String(d));
      set(n, '[data-fls-h]', pad(h));
      set(n, '[data-fls-m]', pad(m));
      set(n, '[data-fls-s]', pad(s % 60));
      n.classList.add('is-ready');
    }
  }

  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() { stop(); tick(); if (c.state() !== 'post') timer = setInterval(tick, 1000); }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
  window.addEventListener('pageshow', start);

  // «lunes 5 de octubre a las 00:00», en hora de Chile.
  function when(ms) {
    try {
      var tz = 'America/Santiago';
      var day = new Intl.DateTimeFormat('es-CL', { timeZone: tz, weekday: 'long', day: 'numeric', month: 'long' }).format(new Date(ms));
      var hour = new Intl.DateTimeFormat('es-CL', { timeZone: tz, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(ms));
      return day.replace(',', '') + ' a las ' + hour;
    } catch (e) { return ''; }
  }

  // Aviso de la vista previa (tema sin publicar o editor de temas). Antes del
  // inicio, fls-campaign-head muestra la campaña como activa por defecto: el
  // aviso dice que es una simulación, cuándo se activa de verdad en el sitio
  // publicado, y deja pasar de un modo al otro. Nunca aparece en el tema
  // publicado: ahí fls-campaign-head no simula y c.preview es falso.
  function simNotice() {
    if (!c.preview || document.querySelector('.fls-sim')) return;
    var t = Date.now();
    var real = t < c.start ? 'pre' : t <= c.end ? 'on' : 'post';
    // Se ve lo que hay: sin aviso.
    if (!c.simulated && real === 'on') return;

    var st = c.state();
    var label = c.label || 'Campaña';
    var title, note = '';
    if (c.simulated) {
      if (st === 'on') {
        title = label + ' activo (simulado)';
        if (real === 'pre') note = 'En el sitio publicado se activa el ' + when(c.start);
        else if (real === 'post') note = 'La campaña ya terminó';
      } else {
        title = st === 'pre' ? 'simulando antes del inicio' : 'simulando campaña terminada';
      }
    } else if (real === 'pre') {
      title = 'fecha real: ' + label + ' aún no parte';
      note = 'Se activa el ' + when(c.start);
    } else {
      title = 'fecha real: campaña terminada';
    }

    var box = document.createElement('div');
    box.className = 'fls-sim';
    box.setAttribute('role', 'status');

    var txt = document.createElement('span');
    txt.className = 'fls-sim__text';
    var strong = document.createElement('strong');
    strong.textContent = 'Vista previa · ' + title;
    txt.appendChild(strong);
    if (note) {
      var small = document.createElement('small');
      small.textContent = note;
      txt.appendChild(small);
    }

    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'fls-sim__go';
    go.textContent = c.simulated ? 'Ver fecha real' : 'Ver como activo';
    go.addEventListener('click', function () {
      // La orden viaja en el #fragmento; el listener de hashchange recarga.
      var target = '#cyber=' + (c.simulated ? 'auto' : 'on');
      if (location.hash === target) location.reload(); else location.hash = target;
    });

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'fls-sim__close';
    close.setAttribute('aria-label', 'Ocultar aviso');
    close.textContent = '×';
    close.addEventListener('click', function () { box.remove(); });

    box.appendChild(txt);
    box.appendChild(go);
    box.appendChild(close);
    document.body.appendChild(box);
  }

  // Cambiar solo el #fragmento no recarga la página: si trae una orden de
  // simulación, se recarga para que fls-campaign-head la lea. Solo en vista previa.
  if (c.preview) {
    window.addEventListener('hashchange', function () {
      if (/(?:^|[#&])(cyber|fls_now)=/.test(location.hash)) location.reload();
    });
  }

  function init() { start(); simNotice(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
